var globalTooltipVariables = {
    openTimeoutId: undefined,
    closeTimeoutId: undefined,
    closeCallback: undefined,
};
/**
 * @description A function that utilises the globalTooltipVariables to ensure only
 *              1 tooltip can be opened at at time
 *
 * @param {number} [runSetTooltipOpenStateDelay=0]
 * @param {(isOpen: boolean) => void} setTooltipOpenState
 */
export var openTooltipHandler = function (runSetTooltipOpenStateDelay, setTooltipOpenState) {
    if (runSetTooltipOpenStateDelay === void 0) { runSetTooltipOpenStateDelay = 0; }
    var closeTimeoutId = globalTooltipVariables.closeTimeoutId, openTimeoutId = globalTooltipVariables.openTimeoutId, closeCallback = globalTooltipVariables.closeCallback;
    clearTimeout(closeTimeoutId);
    clearTimeout(openTimeoutId);
    if (closeCallback && setTooltipOpenState !== closeCallback) {
        closeCallback(false);
    }
    if (runSetTooltipOpenStateDelay > 0) {
        globalTooltipVariables.openTimeoutId = window.setTimeout(function () {
            setTooltipOpenState(true);
        }, runSetTooltipOpenStateDelay);
    }
    else {
        setTooltipOpenState(true);
    }
};
/**
 * @description A function that utilises the globalTooltipVariables to close tooltips
 *
 * @param {number} [runSetTooltipOpenStateDelay=0]
 * @param {(isOpen: boolean) => void} setTooltipOpenState
 */
export var closeTooltipHandler = function (runSetTooltipOpenStateDelay, setTooltipOpenState) {
    if (runSetTooltipOpenStateDelay === void 0) { runSetTooltipOpenStateDelay = 0; }
    var closeTimeoutId = globalTooltipVariables.closeTimeoutId, openTimeoutId = globalTooltipVariables.openTimeoutId;
    clearTimeout(openTimeoutId);
    clearTimeout(closeTimeoutId);
    if (runSetTooltipOpenStateDelay > 0) {
        globalTooltipVariables.closeCallback = setTooltipOpenState;
        globalTooltipVariables.closeTimeoutId = window.setTimeout(function () {
            setTooltipOpenState(false);
        }, runSetTooltipOpenStateDelay);
    }
    else {
        setTooltipOpenState(false);
    }
};
//# sourceMappingURL=tooltipOpenStateHandlers.js.map